import React from 'react';
import { styled } from 'styled-components';

import TbodySeparator from '../TbodySeparator.tsx';
import Td, { Wrapper as TdWrapper } from '../Td.tsx';
import Tr from '../Tr.tsx';
import { footerDropContext } from './DndContext.ts';

export const Footer = styled.tbody`
  ${TdWrapper} {
    border-top: 2px solid ${({ theme }) => theme.colors.grey30_1};
  }
`;

const TbodyFooter: React.FC = () => {
  const footer = React.useContext(footerDropContext);
  return (
    <>
      <Footer ref={footer}>
        <Tr>
          <Td type='sub' />
        </Tr>
      </Footer>
      <TbodySeparator />
    </>
  );
};

export default TbodyFooter;
